export default __webpack_public_path__ + "static/media/enghien07.5da41dc4.jpg";